import { MatchedIpa } from "../pattern/searchAndReplace";
import { IpaType } from "../phonemes/ipa";
import { PhonemeItem } from "../phonemes/segmentPhonemes";
import { applyRuleToWord } from "./applyRule";
import { CompiledRule } from "./compileRule";
import { DiacriticRule, runDiacriticRule } from "./diacriticRule";

/**
 * apply sets of rules to a sentence of phonemes
 */
export function applyRules(
  phonemes: PhonemeItem[], rules: CompiledRule[], subsetMatches?: boolean,
  diacriticRules?: DiacriticRule[], rules2?: CompiledRule[][], ignoreNumbers?: '#'
): string {
  let all: IpaType[] = [];
  let word: IpaType[] = [];
  for (const phoneme of phonemes) {
    if (phoneme.phoneme !== ' ') {
      // build up a word
      word.push(phoneme.phoneme);
    } else if (word.length > 0) {
      // we hit a space, so convert current word
      all = all.concat(runRulesOnWord(word, rules, subsetMatches, diacriticRules, rules2, ignoreNumbers));
      all.push(' ');
      word = [];
    }
  }
  // add in final word
  all = all.concat(runRulesOnWord(word, rules, subsetMatches, diacriticRules, rules2, ignoreNumbers));

  let result = '';
  all.forEach(s => result += s);
  return result;
}

function runRulesOnWord(
  word: IpaType[], rules: CompiledRule[], subsetMatches?: boolean,
  diacriticRules?: DiacriticRule[], rules2?: CompiledRule[][], ignoreNumbers?: '#'
): IpaType[] {
  // run rules, making sure to replace each phoneme no more than once
  let updates: MatchedIpa = { ipa: word, replaced: [] };
  // don't do subset matching if there are diacritic rules because they may conflict
  const subset1 = diacriticRules === undefined ? subsetMatches : false;
  rules.forEach(rule => { updates = applyRuleToWord(updates, rule, subset1, ignoreNumbers); });

  if (diacriticRules) {
    diacriticRules.forEach(dr => { updates = runDiacriticRule(updates, rules, dr, subsetMatches); });
    if (subsetMatches) {
      // runDiacriticRule only reran rules with subsetMatches if it ran a diacritic rule,
      // thus we need another pass to do a final replacement just in case it didn't already
      rules.forEach(rule => { updates = applyRuleToWord(updates, rule, true, ignoreNumbers); });
    }
  }

  if (rules2 !== undefined && rules2.length > 0) {
    // do the same with the additional sets of rules, starting over with replacements
    for (const ruleSet of rules2) {
      updates = { ipa: updates.ipa, replaced: [] };
      for (const rule of ruleSet) {
        updates = applyRuleToWord(updates, rule, subsetMatches, ignoreNumbers);
      }
    }
  }
  return updates.ipa;
}

